export const SET_ASCENDING = 'TOASTER_SETTINGS_SET_ASCENDING'
export const SET_MAX_VISIBLE = 'TOASTER_SETTINGS_SET_MAX_VISIBLE'
export const SET_TIMEOUT_BAR_VISIBILITY = 'TOASTER_SETTINGS_SET_TIMEOUT_BAR_VISIBILITY'
export const SET_REPEAT_COUNT_VISIBILITY = 'TOASTER_SETTINGS_SET_REPEAT_COUNT_VISIBILITY'



// WEBPACK FOOTER //
// ./src/features/Toaster/data/settings/constants.js